var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":_vm.transition}},[_c('span',{staticClass:"mm-tag",class:{
      [`mm-tag__${_vm.type}`]: _vm.type,
      [`mm-tag__${_vm.size}`]: _vm.size,
      'mm-tag--hit': _vm.hit,
      'mm-tag__radius': _vm.radius,
    },style:({
      backgroundColor: _vm.backgroundColor,
      color: _vm.color,
      borderColor: _vm.bordered ? _vm.color : _vm.backgroundColor,
    })},[_vm._t("default"),(_vm.closable)?_c('ui-icon',{staticClass:"mm-tag-close",attrs:{"name":"close","size":"12px"},on:{"click":function($event){$event.stopPropagation();return _vm.handleClose.apply(null, arguments)}}}):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }